import { FullscreenService } from './../fullscreen.module/fullscreen.service';
import { Component, ComponentRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { LoggerService } from '../../../shared/sdk/index';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.css']
})
export class PanelComponent implements OnInit {

  public isCollapsed = false;
  public isRefreshing = false;
  public isPanelFullscreen = false;
  public isClosed = false;
  public showborder = true;
  public hasControls = false;

  @Input() panelRef;
  @Input() panelname;
  @Input() toolrefresh = false;
  @Input() toolcollapse = false;
  @Input() toolexpand = false;
  @Input() tooldismiss = false;
  @Input() id;
  @Input() title: string;
  @Input() titleSize = 'h4';
  @Input() padding = true;
  @Input() subTitle;
  @Input() hideborder = false;

  @Output() onCollapsed = new EventEmitter();
  @Output() onRefresh = new EventEmitter();
  @Output() onRefreshDone = new EventEmitter();
  @Output() onExpand = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @ViewChild('thisPanel') thisPanel;

  constructor(
    public logger: LoggerService,
    public renderer: Renderer2,
    public fullscreen: FullscreenService
  ) {



  }

  ngOnInit() {

    if (this.hideborder) {
      this.showborder = false;
    }
    this.hasControls = this.toolrefresh || this.toolcollapse || this.toolexpand || this.tooldismiss;

  }

  onCloseHandler(event) {
    this.onClose.emit(event); // bubble event
    this.renderer.addClass(this.thisPanel.nativeElement, 'hidepanel');

    setTimeout(() => {
      this.isClosed = true;
    }, 500);
  }

  onPanelCollapseHandler(event) {
    this.isCollapsed = event.isCollapsed;
    this.onCollapsed.emit(event); // bubble event
  }

  onRefreshHandler(event) {
    this.isRefreshing = event.isRefreshing;
    this.onRefresh.emit(event); // bubble up event
  }

  onRefreshDoneHandler(event) {
    this.isRefreshing = event.isRefreshing;
    this.onRefreshDone.emit(event); // bubble up event
  }

  onExpandHandler(event) {
    this.isPanelFullscreen = event.isPanelFullscreen;

    if (this.isPanelFullscreen) {
      this.renderer.addClass(this.thisPanel.nativeElement, 'panel-fullscreen');
    } else {
      this.renderer.removeClass(this.thisPanel.nativeElement, 'panel-fullscreen');
    }


    this.onExpand.emit(event);
    this.fullscreen.setFullScreenOnElement(this.thisPanel.nativeElement, event.isPanelFullscreen);
  }


}



// WEBPACK FOOTER //
// ./src/app/core.module/modules/panel.module/panel.component.ts